import { inject } from '@aesop-fables/containr';
import { Predicate, predicate } from '@aesop-fables/scrinium';
import { Observable, combineLatest, map } from 'rxjs';
import { Predicates } from './Types';
import { drillDownWizardKey, DrillDownWizard, AdminTierTypeEnum } from '../services/drillDown';

@predicate(Predicates.GroupSelected)
export class GroupAdminRolesResolved implements Predicate {
  constructor(
    @inject(drillDownWizardKey)
    private readonly drillDownWizard: DrillDownWizard,
  ) {}

  createObservable(): Observable<boolean> {
    return combineLatest([
      this.drillDownWizard.initialized$,
      this.drillDownWizard.highestAccess$,
    ]).pipe(
      map(
        ([initialized, highestAccess]) => initialized && highestAccess === AdminTierTypeEnum.Group,
      ),
    );
  }
}
